<div class="input-container">
  @if (client.onboarding.csr.capture_written_consent === 'true') {
    <p>Express written consent terms and conditions</p>
    <textarea [formControl]="consentFormGroup.controls['written_consent_language']"
      [ngClass]="{'has-error': !consentFormGroup.controls['written_consent_language'].valid && consentFormGroup.controls['written_consent_language'].touched}"
    placeholder="Please enter consent terms and conditions"></textarea>
    <app-error-display 
      [control]="consentFormGroup.controls['written_consent_language']" 
      [customErrorMessageProvider]="getTooltipData.bind(this)">
    </app-error-display>
  }

  @if (client.onboarding.csr.capture_written_consent === 'false') {
    <p>Express consent terms and conditions</p>
    <textarea [formControl]="consentFormGroup.controls['express_consent_language']"
      [ngClass]="{'has-error': !consentFormGroup.controls['express_consent_language'].valid && consentFormGroup.controls['express_consent_language'].touched}"
    placeholder="Please enter consent terms and conditions"></textarea>
    <app-error-display 
      [control]="consentFormGroup.controls['express_consent_language']" 
      [customErrorMessageProvider]="getTooltipData.bind(this)">
    </app-error-display>
  }
</div>